import { render, staticRenderFns } from "./DisplayModal.vue?vue&type=template&id=35750300&"
import script from "./DisplayModal.vue?vue&type=script&lang=js&"
export * from "./DisplayModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports